import { Box, Button, Tab, Tabs, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import BackOfficeCompanyProfile from "./BackOfficeCompanyProfile";
import { RootState } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { changeBackofficeTab } from "../../store/slices/function/sideBar-filterTabSlice";
import BackOfficeCompanyBD from "./BackOfficeCompanyBD";
import BackOfficeCompanyPreferences from "./BackOfficeCompanyPreferences";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
  
const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

return (
    <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
    >
    {value === index && (
        <Box sx={{ p: 0 }}>
        {children}
        </Box>
    )}
    </div>
);
}

function BackOfficeTabs({ props }:any) {
    const dispatch = useDispatch()
    const tabs = useSelector((state: RootState) => state.backofficeTabs)
    const location = useLocation()

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        dispatch(changeBackofficeTab({ tab: newValue }))
      };

  return (
    <Box sx={{paddingInline: '0.5rem', paddingBlockEnd: '0.5rem', position: 'sticky', top: '0'}}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Tabs value={tabs.tab} onChange={handleChange} >
            <Tab label="Dados Empresa" /> 
            <Tab label="Configurações Entra ID (AD)"/>
            <Tab label="Preferências"/>
        </Tabs>
        </Box>
        <CustomTabPanel value={tabs.tab} index={0} >
            <BackOfficeCompanyProfile />
        </CustomTabPanel>
        <CustomTabPanel value={tabs.tab} index={1}>
            <BackOfficeCompanyBD />
        </CustomTabPanel>
        <CustomTabPanel value={tabs.tab} index={2}>
            <BackOfficeCompanyPreferences />
        </CustomTabPanel>
  </Box>
  );
}

export default BackOfficeTabs;